import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { Account } from '~/features/workspaces/types.ts'

import { useApiSWR } from './useApiSWR.ts'
import Url from '../../utils/Url.ts'

/**
 * This hook retrieves the slug for the active workspace from
 * the URL, LocalStorage or the API, in that order.
 */
export const useWorkspaceSlug = () => {
  // 1. primary source of truth is the slug in the URL
  const { workspace: slugFromUrl } = useParams<{ workspace?: string }>()

  // 2. if we don't have a slug from the URL, check localstorage
  const slugFromLs = Url.getWorkspaceSlugFromLocalStorage()

  // 3. if we don't have a slug from url or localstorage, fetch it from the API
  const { data, isLoading, error } = useApiSWR('/user/current.json', { out: Account })

  return useMemo(
    () => ({
      slug: slugFromUrl ?? slugFromLs ?? data?.login_data.active_workspace_slug,
      isFirstWorkspace: !!(data && data.memberships.length === 0),
      isLoading,
      error,
    }),
    [data, error, isLoading, slugFromLs, slugFromUrl],
  )
}
